<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <!-- <FloatingChat
      v-if="showFloatingChat"
      :user-sig="generateUserSig($store.state.user.userCode)"
      :user-id="$store.state.user.userCode"
      :is-customer-service="$store.state.user.userCode === 'admin' ? false:true"
    /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import FloatingChat from '@/components/im/im.vue'

export default {
  name: 'App',
  components: {
    // FloatingChat
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      code: '',
      Show: false,
      showFloatingChat: false // 控制是否显示悬浮聊天按钮
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user,
      userRole: state => state.user.userRole
    }),
    isCustomerService() {
      return this.userRole === 'code001'
    }
  },
  // watch: {
  //   // 监听路由变化
  //   $route(to) {
  //     // 如果是登录页，隐藏悬浮聊天按钮
  //     setTimeout(() => {
  //       this.showFloatingChat = to.path !== '/dc/admin/login'
  //     }, 300)
  //   }
  // },
  created() {
    // 初始化应用设置
    this.$store.dispatch('setting/init')
    this.$store.dispatch('setLabels')
    this.code = this.$store.state.user.userCode

    // 确保用户信息存在后初始化IM
    // if (this.$store.state.user.userCode) {
    //   this.$store.dispatch('im/loginIM')
    // }

    // setTimeout(() => {
    //   if (this.$route.path !== '/dc/admin/login') {
    //     this.showFloatingChat = true
    //   } else {
    //     this.showFloatingChat = false
    //   }
    // }, 300)

    // 添加首页视图
    const view = {
      pCode: "",
      name: "首页",
      url: "/base/home"
    }
    this.$store.dispatch('tagsView/addView', view)

    // 初始化用户状态监听
    // this.initUserWatch()
  },
  updated() {
    // 绑定界面刷新事件
    window.addEventListener('unload', this.saveState)
    document.body.ondragstart = null
  },
  mounted() {
    // setTimeout(() => {
    //    // 初始判断是否显示悬浮聊天按钮
    // this.showFloatingChat = this.$route.path !== '/dc/admin/login'
    // }, 300);

    // 监听登录成功事件
    this.$root.$on('user-logged-in', this.handleUserLoggedIn)
    this.$on('new-im-message', this.handleGlobalMessage)
  },
  methods: {
    // 处理全局消息
    handleGlobalMessage(message) {
      // 确保消息被所有聊天实例处理
      this.$children.forEach(child => {
        if (child.handleNewMessage) {
          try {
            child.handleNewMessage({ data: [message] })
          } catch (e) {
            console.error('处理消息失败', e)
          }
        }
      })
    },

    // 当页面刷新时vuex存储的数据会消失，因此使用sessionStorage处理
    saveState() {
      sessionStorage.setItem('state', JSON.stringify(this.$store.state))
    },
    // 处理用户登录事件
    handleUserLoggedIn() {
      // 用户登录后显示悬浮聊天按钮
      this.showFloatingChat = true
    },
    // 刷新路由
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },

    // 初始化用户状态监听
    initUserWatch() {
      // 监听用户登录状态变化
      this.$store.watch(
        state => state.user.userCode,
        (newCode, oldCode) => {
          if (newCode && !oldCode && newCode !== '') {
            // 用户登录时触发IM登录
            this.$store.dispatch('im/loginIM')
          } else if (!newCode && oldCode) {
            // 用户登出时触发IM登出
            this.$store.dispatch('im/logoutIM')
          }
        },
        { immediate: true }
      )

      // 监听用户角色变化
      this.$store.watch(
        state => state.user.userRole,
        (newRole) => {
          if (newRole === 'code001') {
            // 如果是客服角色，初始化客服系统
            this.$store.dispatch('im/initCustomerSystem')
          }
        },
        { immediate: true }
      )
    },

    /**
     * 生成UserSig (仅用于演示)
     * 实际项目中应从后端API获取UserSig
     */
    generateUserSig(userID) {
      // 这里是一个伪实现，实际应从服务器获取
      if (userID === 'admin') {
        return `eJwtzE0LgkAUheH-MuuQO5O3YYQ2aotSWpQEtpNmlJuN6CTRB-33TF2e58D7YVl69B7GsYAJD9hi3KRN01NJIxfaUjMfd10XbUuaBdwHwKVSUk2PebbkzOCIKABg0p7s3yQKoQQgnytUDd1dFp3CeFNeXMpt9zrLa5JktlrdeHR4o*ty2YTltt6L3F*z7w8ojDE*`
      } else if (userID === 'code001') {
        return `eJwtzE0LgkAUheH-MuuQ6*RFR2hVVpDZh5HUrpprXaIczIYi*u*ZujzPgfcjNnHqWCpFKKQDotds1nSvOOeGT4UmALe7Hvp6MIa1CF0PAPtK*ap96GW4pNoRUQJAqxXf-uajlCpQiF2Fz3XZXXg4uyQ2N4oofUK8oqMdRpP5epntkvH07e2DrS1HWRENxPcHT9sxag__`
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/flex.scss";
</style>
